import axios from "axios";

export default {
    namespaced: true,

    state: {
        associatedLabs: null,
        brands: null,
        customers: null,
        employees: null,
        examSampleStatuses: null,
        itemGroups: null,
        locations: null,
        locationsList: null,
        vendorsList: null,
        manufacturers: null,
        permissionActions: null,
        roles: null,
        services: null,
        serviceWorkflows: null,
        specialties: null,
        stockMovementTypes: null,
        formCategories: null,
    },

    mutations: {
        getAssociatedLabsSuccess(state, associatedLabs) {
            state.associatedLabs = associatedLabs;
        },

        getLocationsSuccess(state, locations) {
            state.locations = locations;
        },

        getCustomersSuccess(state, customers) {
            state.customers = customers;
        },

        getLocationsListSuccess(state, locations) {
            state.locationsList = locations;
        },

        getVendorsListSuccess(state, vendors) {
            state.vendorsList = vendors;
        },

        gerServicesSuccess(state, services) {
            state.services = services;
        },

        getEmployeesSuccess(state, employees) {
            state.employees = employees;
        },

        getServiceWorkflowsSuccess(state, serviceWorkflows) {
            state.serviceWorkflows = serviceWorkflows;
        },

        getBrandsSuccess(state, brands) {
            state.brands = brands;
        },

        getManufacturersSuccess(state, manufacturers) {
            state.manufacturers = manufacturers;
        },

        getRolesSuccess(state, roles) {
            state.roles = roles;
        },

        getStockMovementTypesSuccess(state, types) {
            state.stockMovementTypes = types;
        },

        getExamSampleStatusesSuccess(state, types) {
            state.examSampleStatuses = types;
        },

        getItemGroupsSuccess(state, itemGroups) {
            state.itemGroups = itemGroups;
        },

        getPermissionActionsSuccess(state, permissionActions) {
            state.permissionActions = permissionActions;
        },

        getSpecialtiesSuccess(state, specialties) {
            state.specialties = specialties;
        },

        getFormCategoriesSuccess(state, formCategories) {
            state.formCategories = formCategories;
        },
    },

    actions: {
        getAssociatedLabs({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/associated-labs/list")
                    .then((res) => {
                        commit("getAssociatedLabsSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getLocations({ commit }, payload = undefined) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/locations/all", {
                        params: {
                            check_role: 1,
                            ...payload,
                        },
                    })
                    .then((res) => {
                        commit("getLocationsSuccess", res.data?.data?.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getLocationsList({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/locations/list")
                    .then((res) => {
                        commit("getLocationsListSuccess", res.data?.data?.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getVendorsList({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/manufacturers/list")
                    .then((res) => {
                        commit("getVendorsListSuccess", res.data?.data?.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getStatistics({ commit }, param) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/statistics", param)
                    .then((res) => {
                        resolve(res.data.statistics);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getLabWiseExam({ commit }, param) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/associated-labs/wise-exam", param)
                    .then((res) => {
                        resolve(res.data.datas);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getServices({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/services/select", {
                        params,
                    })
                    .then((res) => {
                        commit("gerServicesSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getServiceWorkflows({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/service-workflows/list")
                    .then((res) => {
                        commit(
                            "getServiceWorkflowsSuccess",
                            res.data.data.datas
                        );
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getSampleCollectedBy({ commit }, requestParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`employees/get-sample-collected-by?${requestParams}`)
                    .then((res) => {
                        resolve(res.data.data.employees);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getEmployees({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/employees/list")
                    .then((res) => {
                        commit("getEmployeesSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getBrands({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/brands/list")
                    .then((res) => {
                        commit("getBrandsSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getManufacturers({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/manufacturers/list")
                    .then((res) => {
                        commit("getManufacturersSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getRoles({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/roles/list")
                    .then((res) => {
                        commit("getRolesSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getStockMovementTypes({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/stock-movements/get-types")
                    .then((res) => {
                        commit(
                            "getStockMovementTypesSuccess",
                            res.data.data.types
                        );
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getExamSampleStatuses({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/exams/exam-samples/statuses")
                    .then((res) => {
                        commit(
                            "getExamSampleStatusesSuccess",
                            res.data.data.statuses
                        );
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getItemGroups({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/item-groups/list")
                    .then((res) => {
                        commit("getItemGroupsSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getPermissionActions({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/permissions/actions")
                    .then((res) => {
                        commit(
                            "getPermissionActionsSuccess",
                            res.data.data.actions
                        );
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getSpecialties({ commit }, requestParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/specialties/list/${requestParams}`)
                    .then((res) => {
                        commit("getSpecialtiesSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        accessDownloadReport({ commit }, accessData) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/download-reports", {
                        params: accessData,
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getCustomers({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/customers/all")
                    .then((res) => {
                        commit("getCustomersSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getFormCategories({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/settings/forms/categories/list")
                    .then((res) => {
                        commit("getFormCategoriesSuccess", res.data.data.datas);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {
        associatedLabs: (state) => state.associatedLabs,
        brands: (state) => state.brands,
        customers: (state) => state.customers,
        employees: (state) => state.employees,
        examSampleStatuses: (state) => state.examSampleStatuses,
        itemGroups: (state) => state.itemGroups,
        locations: (state) => state.locations,
        locationsList: (state) => state.locationsList,
        vendorsList: (state) => state.vendorsList,
        manufacturers: (state) => state.manufacturers,
        permissionActions: (state) => state.permissionActions,
        roles: (state) => state.roles,
        services: (state) => state.services,
        serviceWorkflows: (state) => state.serviceWorkflows,
        specialties: (state) => state.specialties,
        stockMovementTypes: (state) => state.stockMovementTypes,
        formCategories: (state) => state.formCategories,
    },
};
